// extracted by mini-css-extract-plugin
export default {"__wrapper":"Register___wrapper__nQ7gl"};